export default __webpack_public_path__ + "img/fyBSuGcJ.b884dcd7.svg";